import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from '../../utils/firebase';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import LoginHeader from '../login/components/LoginHeader';
import TrustSignals from '../login/components/TrustSignals';

const ForgotPassword = () => {
  return (
    <>
      <Helmet>
        <title>Reset Password - InventoryTracker | Secure Business Inventory Management</title>
        <meta name="description" content="Reset your InventoryTracker account password. Secure access to comprehensive inventory management tools for your business operations." />
        <meta name="keywords" content="password reset, forgot password, inventory management, secure access" />
      </Helmet>
      <div className="min-h-screen bg-background">
        {/* Main Content Container */}
        <div className="container mx-auto px-4 py-8 lg:py-12">
          {/* Header Section */}
          <LoginHeader />

          {/* Forgot Password Form Section */}
          <div className="flex justify-center mb-16">
            <ForgotPasswordForm />
          </div>

          {/* Trust Signals Section */}
          <TrustSignals />
        </div>

        {/* Footer */}
        <footer className="border-t border-border bg-card mt-16">
          <div className="container mx-auto px-4 py-8">
            <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
              <div className="text-sm text-muted-foreground">
                © {new Date()?.getFullYear()} InventoryTracker. All rights reserved.
              </div>
              <div className="flex items-center space-x-6 text-sm text-muted-foreground">
                <a href="#" className="hover:text-foreground transition-hover">Privacy Policy</a>
                <a href="#" className="hover:text-foreground transition-hover">Terms of Service</a>
                <a href="#" className="hover:text-foreground transition-hover">Support</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ForgotPassword;